export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13595.b57852b8.jpg";